export default __webpack_public_path__ + "static/media/scottish-friendly-logo.120889b7.svg";